// Small display helpers shared by the shop and the admin panel

export const API_URL = process.env.REACT_APP_API_URL || '';

export const formatPrice = (amount) => `৳${Number(amount || 0).toFixed(2)}`;

// Orders are shown to people by the last 6 characters of their Mongo id
export const shortOrderId = (id) => (id ? `#${id.slice(-6).toUpperCase()}` : '');

export const PLACEHOLDER_IMAGE = 'https://placehold.co/400x400/f0f0f0/c7c7c7?text=No+Image';

// Product images come from the API as "/api/products/..." paths; uploads in the admin form are data URLs
export const resolveImage = (url) => {
    if (!url) return PLACEHOLDER_IMAGE;
    if (url.startsWith('/api/')) return `${API_URL}${url}`;
    return url;
};

export const firstImage = (product) =>
    resolveImage(Array.isArray(product?.imageUrls) ? product.imageUrls[0] : null);

// --- Bangladeshi phone numbers (accepts Bangla digits, spaces, dashes, +88) ---
const BANGLA_DIGITS = '০১২৩৪৫৬৭৮৯';
export const normalizePhone = (value) =>
    String(value || '')
        .replace(/[০-৯]/g, d => BANGLA_DIGITS.indexOf(d))
        .replace(/[\s-]/g, '')
        .replace(/^\+?88(?=01)/, '');
export const isValidBdPhone = (value) => /^01[3-9]\d{8}$/.test(normalizePhone(value));

// --- Login session ---
const isTokenExpired = (token) => {
    try {
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        return payload.exp ? payload.exp * 1000 < Date.now() : false;
    } catch {
        return true;
    }
};

export const clearSession = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
};

// Returns the logged-in user, or null if there is none or the login has expired
export const getStoredUser = () => {
    try {
        const token = localStorage.getItem('token');
        const user = JSON.parse(localStorage.getItem('user'));
        if (!token || !user || isTokenExpired(token)) {
            if (token || user) clearSession();
            return null;
        }
        return user;
    } catch {
        clearSession();
        return null;
    }
};

export const saveSession = ({ token, user }) => {
    if (token) localStorage.setItem('token', token);
    if (user) localStorage.setItem('user', JSON.stringify(user));
};

// Name to greet the user with: their name, old-style username, or phone number
export const displayName = (user) => user?.name || user?.username || user?.phone || 'Customer';

export const logout = () => {
    clearSession();
    window.location.href = '/login';
};

// --- Last delivery details, so returning customers don't retype them at checkout ---
const DELIVERY_KEY = 'lastDelivery';
export const readLastDelivery = () => {
    try {
        return JSON.parse(localStorage.getItem(DELIVERY_KEY)) || {};
    } catch {
        return {};
    }
};
export const saveLastDelivery = (details) => {
    try {
        localStorage.setItem(DELIVERY_KEY, JSON.stringify(details));
    } catch {
        // storage unavailable: just skip remembering
    }
};
